import { syncNewApplicationSeen } from 'shared/utils/counselorSeenSync'

/**
 * Optimistic clear of isNewApplication + persist seen state for counselor.
 */
export const markApplicationSeenIfNew = async row => {
	syncNewApplicationSeen(row)
}
